import { createAsyncThunk } from '@reduxjs/toolkit';
import getUnenhancedOpenPurchase from '../selectors/getUnenhancedOpenPurchase';

// MiM-friendly function to set the substitution selections tree (any getopenpurchase calls should be updated automatically with validity due to the matcher logic)
export const setOpenPurchaseSubstitutionSelections = createAsyncThunk(
  '$setOpenPurchaseSubstitutionSelections',
  async (
    data: {
      newSelections: Record<string, string>;
    },
    { getState, rejectWithValue },
  ) => {
    try {
      const { newSelections } = data;

      if (!newSelections) {
        throw new Error(
          'newSelections required to replace old substitutionSelections',
        );
      }

      const openPurchase = getUnenhancedOpenPurchase(
        getState() as EntireFrontendState,
      )!;

      const adjustedPurchase = {
        ...openPurchase,
        substitutionSelections: newSelections,
      };

      return {
        purchase: adjustedPurchase,
      };
    } catch (e) {
      console.error('Set open purchase substitution selections failed', { e });
      return rejectWithValue(e);
    }
  },
);
